import { _ as a, g as o } from "./export-cdcbfb2b.js";
var r = a, l = o;
r({ global: !0, forced: l.globalThis !== l }, {
  globalThis: l
});
